/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Today_TagInputs */

const en_today_tag = /** @type {(inputs: Today_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Today`)
};

const ar_today_tag = /** @type {(inputs: Today_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اليوم`)
};

const de_today_tag = /** @type {(inputs: Today_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heute`)
};

const es_today_tag = /** @type {(inputs: Today_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoy`)
};

const fr_today_tag = /** @type {(inputs: Today_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aujourd'hui`)
};

const it_today_tag = /** @type {(inputs: Today_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oggi`)
};

const ja_today_tag = /** @type {(inputs: Today_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`今日`)
};

const ko_today_tag = /** @type {(inputs: Today_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`오늘`)
};

const pt_br_today_tag = /** @type {(inputs: Today_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoje`)
};

const ru_today_tag = /** @type {(inputs: Today_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сегодня`)
};

const th_today_tag = /** @type {(inputs: Today_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`วันนี้`)
};

const tr_today_tag = /** @type {(inputs: Today_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bugün`)
};

const zh_cn_today_tag = /** @type {(inputs: Today_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`今天`)
};

const zh_tw_today_tag = /** @type {(inputs: Today_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`今天`)
};

/**
* | output |
* | --- |
* | "Today" |
*
* @param {Today_TagInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const today_tag = /** @type {((inputs?: Today_TagInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Today_TagInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_today_tag(inputs)
	if (locale === "ar") return ar_today_tag(inputs)
	if (locale === "de") return de_today_tag(inputs)
	if (locale === "es") return es_today_tag(inputs)
	if (locale === "fr") return fr_today_tag(inputs)
	if (locale === "it") return it_today_tag(inputs)
	if (locale === "ja") return ja_today_tag(inputs)
	if (locale === "ko") return ko_today_tag(inputs)
	if (locale === "pt_br") return pt_br_today_tag(inputs)
	if (locale === "ru") return ru_today_tag(inputs)
	if (locale === "th") return th_today_tag(inputs)
	if (locale === "tr") return tr_today_tag(inputs)
	if (locale === "zh_cn") return zh_cn_today_tag(inputs)
	return zh_tw_today_tag(inputs)
});